// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Login-module__loginContainer {
  display: flex;
  height: calc(100vh - 108px);
  width: 100%;
  position: relative;
  overflow: hidden;
}

.Login-module__leftSection {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 5%;
  z-index: 1;
}

.Login-module__rightSection {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.Login-module__title {
  font-size: 2.5rem;
  font-weight: 400;
  line-height: 100%;
  color: #00354e;
  margin-bottom: 1rem;
}

.Login-module__title span {
  font-weight: 700;
  text-transform: uppercase;
}

.Login-module__loginForm {
  margin-top: 20px;
}

.Login-module__mainImage {
  position: absolute;
  bottom: 0;
  right: 0;
  max-width: 100%;
  height: auto;
}

.Login-module__topImage {
  position: absolute;
  top: -10%;
  right: 0;
  width: 50%;
  z-index: -1;
}

.Login-module__bottomImage {
  position: absolute;
  bottom: -20%;
  left: -10%;
  width: 40%;
  z-index: 0;
}

@media (max-width: 768px) {
  .Login-module__loginContainer {
    flex-direction: column;
    height: auto;
  }

  .Login-module__rightSection {
    order: 2;
    padding: 20px;
  }

  .Login-module__leftSection {
    order: 1;
    padding: 20px;
    text-align: center;
  }

  .Login-module__title {
    font-size: 2rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/login/Login.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,2BAA2B;EAC3B,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,aAAa;EACb,UAAU;AACZ;;AAEA;EACE,OAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,eAAe;EACf,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,QAAQ;EACR,UAAU;EACV,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,UAAU;EACV,UAAU;EACV,UAAU;AACZ;;AAEA;EACE;IACE,sBAAsB;IACtB,YAAY;EACd;;EAEA;IACE,QAAQ;IACR,aAAa;EACf;;EAEA;IACE,QAAQ;IACR,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,eAAe;EACjB;AACF","sourcesContent":[".loginContainer {\n  display: flex;\n  height: calc(100vh - 108px);\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n}\n\n.leftSection {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 0 5%;\n  z-index: 1;\n}\n\n.rightSection {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.title {\n  font-size: 2.5rem;\n  font-weight: 400;\n  line-height: 100%;\n  color: #00354e;\n  margin-bottom: 1rem;\n}\n\n.title span {\n  font-weight: 700;\n  text-transform: uppercase;\n}\n\n.loginForm {\n  margin-top: 20px;\n}\n\n.mainImage {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  max-width: 100%;\n  height: auto;\n}\n\n.topImage {\n  position: absolute;\n  top: -10%;\n  right: 0;\n  width: 50%;\n  z-index: -1;\n}\n\n.bottomImage {\n  position: absolute;\n  bottom: -20%;\n  left: -10%;\n  width: 40%;\n  z-index: 0;\n}\n\n@media (max-width: 768px) {\n  .loginContainer {\n    flex-direction: column;\n    height: auto;\n  }\n\n  .rightSection {\n    order: 2;\n    padding: 20px;\n  }\n\n  .leftSection {\n    order: 1;\n    padding: 20px;\n    text-align: center;\n  }\n\n  .title {\n    font-size: 2rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loginContainer": `Login-module__loginContainer`,
	"leftSection": `Login-module__leftSection`,
	"rightSection": `Login-module__rightSection`,
	"title": `Login-module__title`,
	"loginForm": `Login-module__loginForm`,
	"mainImage": `Login-module__mainImage`,
	"topImage": `Login-module__topImage`,
	"bottomImage": `Login-module__bottomImage`
};
export default ___CSS_LOADER_EXPORT___;
